import axios from 'axios'

export default class TipoUnimed {
  constructor (tokenBearer, url) {
    this.url = `${url}/api/dominios/tipoUnimed`
    this.tokenBearer = tokenBearer
  }

  getTipoUnimed () {
    return new Promise(async (resolve, reject) => {
      let optionsTipoUnimed = {
        method: 'get',
        url: `${this.url}`,
        headers: {
          'Authorization': this.tokenBearer
        }
      }

      try {
        let responseTipoUnimed = await axios(optionsTipoUnimed)
        resolve(responseTipoUnimed)
      } catch (err) {
        reject(err)
      }
    })
  }
}
